import { clientStore } from '../../../../services/axiosInstance'
import { OrderForm } from '../../entity/orderForm'
import type { CustomDataBody } from '../types/customData'

export const addCartCustomData = async (
  orderFormId: string,
  body: CustomDataBody
) => {
  // For now, the CORS configuration only allows homolog and production environments
  if (process.env.NODE_ENV === 'development') {
    return null
  }

  try {
    const { data } = await clientStore.put(
      `/v1/checkout/pub/orderForm/${orderFormId}/customData/${body.appId}`,
      body.customData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return new OrderForm(data)
  } catch (error) {
    console.error('Erro ao adicionar customData')

    return null
  }
}
